import { render, staticRenderFns } from "./ServicePackAdvantages.vue?vue&type=template&id=26c42a54&scoped=true"
import script from "./ServicePackAdvantages.vue?vue&type=script&lang=ts"
export * from "./ServicePackAdvantages.vue?vue&type=script&lang=ts"
import style0 from "./ServicePackAdvantages.vue?vue&type=style&index=0&id=26c42a54&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c42a54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26c42a54')) {
      api.createRecord('26c42a54', component.options)
    } else {
      api.reload('26c42a54', component.options)
    }
    module.hot.accept("./ServicePackAdvantages.vue?vue&type=template&id=26c42a54&scoped=true", function () {
      api.rerender('26c42a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/ServicePackAdvantages.vue"
export default component.exports